import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
})
export class ChangePasswordComponent implements OnInit {
  form: FormGroup;

  constructor(private authService: AuthService, private toast: ToastrService, private router: Router) {
    this.form = new FormGroup({
      password: new FormControl('', [Validators.required]),
      newPassword: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(10)]),
      newPasswordReply: new FormControl(''),
    });
  }

  ngOnInit(): void {
    this.form.controls.newPassword.valueChanges.subscribe((value) => {
      this.form.controls['newPasswordReply'].setErrors({ incorrect: true });
      this.form.updateValueAndValidity();
    });
  }

  save() {
    if (!this.form.valid) {
      this.form.errors;
      return;
    }
    this.authService
      .changePassword(this.form.value)
      .then((res) => {
        this.toast.success(res.message);
        this.form.reset({});
        this.router.navigateByUrl('/dashboard');
      })
      .catch((err) => {
        this.toast.error(err.error.message);
      });
  }
}
